var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.localStorageUser
    ? _c("div", { staticClass: "go-panel go-panel-common" }, [
        _c("div", { staticClass: "go-panel-header" }, [
          _c("h3", [_vm._v(_vm._s(_vm.$t("myPage.scrapeAgent.title")))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "go-panel-body" }, [
          _c(
            "div",
            {
              class: [
                "mypage-agent scrap",
                _vm.scrapAgentStorage.usagePercent > 90 ? "notify" : "",
              ],
            },
            [
              _c("div", { staticClass: "go-storage-area" }, [
                _c("p", { staticClass: "go-text" }, [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("myPage.scrapeAgent.storage"))),
                  ]),
                  _vm._v(" "),
                  _c("small", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("myPage.membership.storage", {
                          usedScrap: _vm.scrapAgentStorage.totalUsed,
                          totalScrap: _vm.scrapAgentStorage.totalStorage,
                        })
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "go-progress" }, [
                  _c(
                    "div",
                    {
                      staticClass: "go-progress-bar go-success",
                      style: {
                        width: (_vm.scrapAgentStorage.usagePercent || 0) + "%",
                      },
                      attrs: {
                        role: "progressbar",
                        "aria-valuenow": _vm.scrapAgentStorage.usagePercent,
                        "aria-valuemin": "0",
                        "aria-valuemax": "100",
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.scrapAgentStorage.usagePercent) +
                          "%\n          "
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.scrapAgentStorage.usagePercent > 90
                ? _c("p", [
                    _c("i", {
                      staticClass: "go-icon-20 go-icon-alert-circle-filled",
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("myPage.membership.storageAlert"))),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "go-detail-btn" }, [
                _vm.isUltraUser()
                  ? _c(
                      "button",
                      {
                        staticClass: "btn go-btn-outline-primary",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.goTo("/pricing-plan")
                          },
                        },
                      },
                      [
                        _c("em", { staticClass: "go-text" }, [
                          _vm._v(_vm._s(_vm.$t("myPage.scrapeAgent.upgrade"))),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mypage-nav" }, [
            _c("dl", [
              _c("dt", [
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.$t("myPage.scrapeAgent.manageCollectChannel"))
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("dd", [
                _c(
                  "button",
                  {
                    staticClass: "btn go-btn-icon",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.goTo("/my-page/collection-channel")
                      },
                    },
                  },
                  [_c("i", { staticClass: "go-icon-24 go-icon-chevron-right" })]
                ),
              ]),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }